//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Video src
     */
    src: {
      type: String,
      default: ''
    },
    /**
     * Video type
     */
    type: {
      type: String,
      default: 'video/mp4'
    }
  }
}
